export default {
  PAGE_NAME_INPUT: 'page-name-input-field',
  PAGE_TEMPLATE_SELECT: 'page-template-select-field',
  DISPLAY_IN_NAVIGATION_CHECKBOX: 'display-in-navigation-checkbox-field',
  TRANSLATE_LANGUAGE_SELECT: 'langCode',
  TRANSLATE_PAGE_ID: 'pageId',
  TRANSLATE_AUTO_TRANS: 'autoTrans',
  EXISTING_PAGE_RESOLVING: 'translateExistingPage',
};
